// src/pages/ResetPassword.js
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post(`/auth/reset-password/${token}`, { password });
      toast.success("Password updated! You can now log in.");
      navigate("/login");
    } catch (err) {
      toast.error("Something went wrong. Link may be invalid or expired.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border rounded shadow bg-white">
      <h1 className="text-xl font-bold mb-4">Reset your password</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="password"
          placeholder="Enter new password"
          value={password}
          autoComplete="new-password"
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />
        <button
          type="submit"
          className="w-full bg-sage text-white py-2 rounded-3xl hover:bg-sagedark"
        >
          Set New Password
        </button>
      </form>
    </div>
  );
}
